import types from '../actionTypes';

export const infoCategoriesRequest = meta => ({
    type: types.INFO_CATEGORIES_REQUEST,
    meta,
});

export const infoCategoriesRequestCompleted = () => ({
    type: types.INFO_CATEGORIES_REQUEST_COMPLETED,
});

export const infoCategoryDetailRequest = (id, silent = false) => ({
    type: types.INFO_CATEGORY_DETAIL_REQUEST,
    meta: {
        id,
        silent,
    },
});

export const infoCategoryDetailRequestCompleted = () => ({
    type: types.INFO_CATEGORY_DETAIL_REQUEST_COMPLETED,
});

export const infoRequest = (id, meta) => ({
    type: types.INFO_REQUEST,
    meta: {
        ...meta,
        id,
    },
});

export const infoRequestCompleted = id => ({
    type: types.INFO_REQUEST_COMPLETED,
    meta: {
        id,
    },
});

export const infoDetailRequest = (categoryId, id, silent = false) => ({
    type: types.INFO_DETAIL_REQUEST,
    meta: {
        categoryId,
        id,
        silent,
    },
});

export const infoDetailRequestCompleted = () => ({
    type: types.INFO_DETAIL_REQUEST_COMPLETED,
});
